import gitKrakenLoading from "../../../../src/images/util/gitkraken_loading.gif";
import gitKrakenMain from "../../../../src/images/util/gitkraken_main.png";
import gitKrakenAccount1 from "../../../../src/images/util/gitkraken_account1.png";
import gitKrakenAccount2 from "../../../../src/images/util/gitkraken_account2.png";
import gitKrakenGitDiff from "../../../../src/images/util/gitkraken_gitdiff.png";
import gitKrakenGUIDiff from "../../../../src/images/util/gitkraken_guidiff.png";
import gitKrakenRepo from "../../../../src/images/util/gitkraken_repo.png";
import gitKrakenRepoMain from "../../../../src/images/util/gitkraken_repo_main.png";
import gitKrakenSettingLight from "../../../../src/images/util/gitkraken_setting_light.png";
import gitKrakenRepoMainLight from "../../../../src/images/util/gitkraken_repo_main_light.png";
import * as React from 'react';
export default {
  gitKrakenLoading,
  gitKrakenMain,
  gitKrakenAccount1,
  gitKrakenAccount2,
  gitKrakenGitDiff,
  gitKrakenGUIDiff,
  gitKrakenRepo,
  gitKrakenRepoMain,
  gitKrakenSettingLight,
  gitKrakenRepoMainLight,
  React
};